/* Company Creation - shared dropdown options & labels */

export const companyTypeOptions = [
    { id: "Private Limited", name: "Private Limited" },
    { id: "Public Limited", name: "Public Limited" },
    { id: "LLP", name: "LLP" },
    { id: "Partnership", name: "Partnership" },
    { id: "Proprietorship", name: "Proprietorship" },
    { id: "Section 8 Company", name: "Section 8 Company" },
    { id: "Other", name: "Other" },
];

export const companyStatusOptions = [
    { id: "Active", name: "Active" },
    { id: "Inactive", name: "Inactive" },
];

export const countryOptions = [
    { id: "India", name: "India" },
    { id: "United States", name: "United States" },
    { id: "United Kingdom", name: "United Kingdom" },
    { id: "United Arab Emirates", name: "United Arab Emirates" },
    { id: "Singapore", name: "Singapore" },
];

export const stateOptions = [
    { id: "Karnataka", name: "Karnataka" },
    { id: "Tamil Nadu", name: "Tamil Nadu" },
    { id: "Maharashtra", name: "Maharashtra" },
    { id: "Telangana", name: "Telangana" },
    { id: "Andhra Pradesh", name: "Andhra Pradesh" },
    { id: "Delhi", name: "Delhi" },
    { id: "Gujarat", name: "Gujarat" },
    { id: "West Bengal", name: "West Bengal" },
    { id: "Kerala", name: "Kerala" },
    { id: "Rajasthan", name: "Rajasthan" },
    { id: "Uttar Pradesh", name: "Uttar Pradesh" },
    { id: "Punjab", name: "Punjab" },
    { id: "Haryana", name: "Haryana" },
    { id: "Odisha", name: "Odisha" },
    { id: "Bihar", name: "Bihar" },
];

export const currencyOptions = [
    { id: "INR", name: "INR" },
    { id: "USD", name: "USD" },
    { id: "EUR", name: "EUR" },
    { id: "GBP", name: "GBP" },
    { id: "AED", name: "AED" },
];

export const accountingPeriodOptions = [
    { id: "Monthly", name: "Monthly" },
    { id: "Quarterly", name: "Quarterly" },
];

export const erpSystemOptions = [
    { id: "SAP S/4HANA", name: "SAP S/4HANA" },
    { id: "SAP B1", name: "SAP B1" },
    { id: "Oracle", name: "Oracle" },
    { id: "Microsoft Dynamics", name: "Microsoft Dynamics" },
    { id: "Other", name: "Other" },
];

export const enabledDisabledOptions = [
    { id: "Enabled", name: "Enabled" },
    { id: "Disabled", name: "Disabled" },
];

export const budgetTypeOptions = [
    { id: "Annual", name: "Annual" },
    { id: "Quarterly", name: "Quarterly" },
    { id: "Monthly", name: "Monthly" },
];

export const budgetControlLevelOptions = [
    { id: "Company", name: "Company" },
    { id: "BU", name: "BU" },
    { id: "Department", name: "Department" },
    { id: "Cost Center", name: "Cost Center" },
];

export const budgetCheckBasisOptions = [
    { id: "PR", name: "PR" },
    { id: "PO", name: "PO" },
    { id: "Both", name: "Both" },
];

export const budgetExceedActionOptions = [
    { id: "Warning", name: "Warning" },
    { id: "Block", name: "Block" },
    { id: "Approval", name: "Approval" },
];

export const budgetApprovalWorkflowOptions = [
    { id: "Standard Budget Approval", name: "Standard Budget Approval" },
    { id: "Escalated Budget Approval", name: "Escalated Budget Approval" },
    { id: "No Workflow", name: "No Workflow" },
];

/* Wizard tabs - same style as RFQ create tabs */
export const companyTabList = [
    { id: "basic-info", label: "Basic Information" },
    { id: "address-contact", label: "Registered Address & Contact" },
    { id: "tax-financial", label: "Tax & Financial Details" },
    { id: "budget-control", label: "Budget Control Settings" },
];

/* Empty form template */
export const getCompanyFormTemplate = () => ({
    documentNumber: "",
    companyCode: "",
    companyName: "",
    legalName: "",
    companyShortName: "",
    companyType: "",
    registrationNumber: "",
    companyLogo: "",
    companyLogoName: "",
    companyStatus: "Active",
    addressLine1: "",
    addressLine2: "",
    country: "India",
    state: "",
    city: "",
    pinCode: "",
    primaryContactPerson: "",
    contactEmail: "",
    contactNumber: "",
    website: "",
    pan: "",
    gstNumber: "",
    currency: "INR",
    financialYearStart: "1 April",
    financialYearEnd: "31 March",
    accountingPeriod: "Monthly",
    erpSystem: "",
    erpCompanyId: "",
    budgetControl: "Disabled",
    budgetType: "Annual",
    budgetControlLevel: "Company",
    budgetCheckBasis: "Both",
    budgetExceedAction: "Warning",
    budgetCarryForward: "Disabled",
    budgetApprovalWorkflow: "",
    defaultBudgetOwner: "",
    budgetTolerancePercent: "",
});
